require('new_design/common/daily_offers_timer/index.js');
